// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"564e5978","453":"6917f3e9"}[chunkId] + ".chunk.js";
};